window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js');
    window.$ = window.jQuery = require('jquery');
    window.bootstrap = require('bootstrap');
    window.moment = require('moment');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

// Store a WeakMap to track modal-specific handlers
const modal_hide_handlers = new WeakMap();
window.handleModalHide = (elements) => {
    // Normalize to array if single element
    if (!Array.isArray(elements) && !(elements instanceof NodeList)) {
        elements = [elements];
    }

    elements.forEach((element) => {
        if (!element) return;

        // If a handler already exists, remove it
        const old_handler = modal_hide_handlers.get(element);
        if (old_handler) {
            element.removeEventListener('hide.bs.modal', old_handler);
        }

        // Create new handler
        const newHandler = function () {
            if (document.activeElement && element.contains(document.activeElement)) {
                document.activeElement.blur();
            }
        };

        // Store and add it
        modal_hide_handlers.set(element, newHandler);
        element.addEventListener('hide.bs.modal', newHandler);
    });
};

// Ensure that Bootstrap is properly loaded before this script
window.showModal = (class_id, options = {}) => {
    // console.log(class_id);
    const element = document.getElementById(class_id);
    if (!element) {
        return;
    }

    handleModalHide(element);

    try {
        const modal = bootstrap.Modal.getOrCreateInstance(element, options);
        modal.show();
    } catch (error) {
        console.log('Error initializing modal:', error);
    }
};

window.hideModal = (class_id) => {
    const element = document.getElementById(class_id);
    if (!element) {
        return;
    }

    handleModalHide(element);

    try {
        const modal = bootstrap.Modal.getOrCreateInstance(element);
        modal.hide();
    } catch (error) {
        console.log('Error initializing modal:', error);
    }
};

// Function to display alert messages
window.showAlertMessage = (message, type='success') => {
    const alert_type = type == 'error' || type == 'failed' ? 'alert-danger' : `alert-${type}`;
    $('body').prepend('<div class="alert ' + alert_type + ' alert-block" role="alert">' + message + '</div>');
    setTimeout(function() {
        $('.alert').fadeOut('slow', function(){
            $(this).remove();
        });
    }, 4000);
}